module.exports = __webpack_public_path__ + "static/27-Arcadyan-8fa9c83d96ca14a017f5676c17bfd9fe.png";